import { postRequestFile } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const updateHardware = async (data, source) => {
  try {
    if (source) return await postRequestFile(urls.UPDATE_HARDWARE_CSP, data);
    else return await postRequestFile(urls.UPDATE_HARDWARE_CASE, data);
  } catch (err) {
    return err;
  }
};
